/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import {
    fetchPolicyCategories,
    fetchPolicyTypes,
    fetchCountries,
    setStep00,
    findAddress,
    getAddress,
    findLatLong,
    companyNameSearch,
    resetQuotes
} from '../../../actions'

/**
 * Import
 * - Page component
 */
import Step00 from '../../../components/pages/Quote/Step00/Step00'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
        address: state.address,
        companyNames: state.companyNames,
        policyCategories: state.step00.policyCategories,
        policyTypes: state.step00.policyTypes,
        countries: state.step00.countries,
    }
}

export default connect(
    mapStateToProps,
    {
        fetchPolicyCategories,
        fetchPolicyTypes,
        fetchCountries,
        setStep00,
        findAddress,
        getAddress,
        getLatLong: findLatLong,
        companyNameSearch,
        resetQuotes,
    }
)(Step00)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/Step00.tsx